import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'libs/connection';
import { SortByAction, FilterByAction } from 'libs/connection/actions';
import { useAppManager, useRouterStore } from 'apps/hooks';
import { Button } from 'components';
import { PortalLink } from 'apps/client/components/PortalLink';
import { IntermediatorSwitcherDescription } from 'apps/client/components/ChangePortalBanner';
import { graphqlIdToDecimal } from 'utils/dgraphId';
import { ShipmentQuotesConnectionManager } from '../connManager';

interface OpenQuoteButtonProps {
  node: {
    id: string;
  };
}

const OpenQuoteButton = ({ node }: OpenQuoteButtonProps) => (
  <PortalLink
    name='quote'
    params={{ quoteId: node.id }}
    openTab={{
      title: `${graphqlIdToDecimal(node.id)}`,
      iconType: 'quote',
    }}
  >
    <Button
      size='small'
      text='Open'
      outline
      icon='arrow_right'
      iconPosition='right'
    />
  </PortalLink>
);

export const QuoteList = observer(() => {
  const conn = useAppManager(ShipmentQuotesConnectionManager, null);
  const routerStore = useRouterStore();

  const actions = {
    leftActions: [SortByAction, FilterByAction],
    rightActions: [
      routerStore.route.name !== 'workspace' &&
        IntermediatorSwitcherDescription,
    ].filter(Boolean),
  };

  return (
    <div id='tableWrapper' className='mt-2'>
      <Table
        {...{
          contentName: 'Quotes',
          subRowsAccessor: 'productQuotes',
          columns: conn.finalColumns,
          actions,
          conn,
          RowActionButtons: OpenQuoteButton,
        }}
      />
    </div>
  );
});
